import React, { Component } from "react";
import { CONTEXT_ROOT } from "../../utils";
import Styles from "./styles.css";
export class PlanAlertPopup extends Component {
  state = {};

  constructor(props) {
    super(props);
  }
  handleProceed = () => {
    const { location, plan,queryRefParam } = this.props;
    const planName=plan && plan.toUpperCase()==='FLEX'?'flex':(plan && plan.toUpperCase()==='FLEXCRS'?'flexCRS':(plan && plan.toUpperCase()==='FLATCRS'?'flatCRS':'flat'));
    const { pathname,search } = location;
    const queryparam=!!queryRefParam?"?ref="+queryRefParam+"&plan="+planName:"?plan="+planName;
    window.location.replace(`${pathname}`+queryparam);
  };

  handleSendEmail = () => {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = "mailto:informazionicommerciali@axerve.com";
    a.click();
    document.body.removeChild(a);
  };

  render() {
    const { plan } = this.props;
    const assetsPath = `${CONTEXT_ROOT}/assets/images/`;

    return (
      <div className="modal">
        <div className="scroll">
          <div className="alert-container">
            <div className="section">
              <div className="img-container">
                <img
                  src={
                    assetsPath +
                    ((plan === "flex" || (plan && plan.toUpperCase()==="FLEXCRS")) ? "easyflexalert.png" : "easyflatalert.png")
                  }
                />
              </div>
              <div className="info-container">
                <div className="description heading">
                  Hai gia una richiesta in corso per l'offerta
                  {(plan === "flex" || (plan && plan.toUpperCase()==="FLEXCRS"))
                    ? " POS Easy a commissioni"
                    : " POS Easy a canone"}
                </div>
                <button onClick={this.handleProceed}>
                  Prosegui con l'offerta a
                  {(plan === "flex" || (plan && plan.toUpperCase()==="FLEXCRS")) ? " commissioni" : " canone"}
                </button>
              </div>
            </div>
            <div className="section">
              <div className="img-container">
                <img
                  src={
                    assetsPath +
                    ((plan === "flex" || (plan && plan.toUpperCase()==="FLEXCRS")) ? "easyflatalert.png" : "easyflexalert.png")
                  }
                />
              </div>
              <div className="info-container">
                <div className="description">
                  Per proseguire con la richiesta del
                  <b>
                    {" "}
                    {(plan === "flex" || (plan && plan.toUpperCase()==="FLEXCRS"))
                      ? "POS Easy a canone"
                      : "POS Easy a commissioni"}{" "}
                  </b>
                  contattaci per richiedere assistenza
                </div>
                <button onClick={this.handleSendEmail}>Contattaci</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanAlertPopup;



// WEBPACK FOOTER //
// ./components/planAlertPopup/index.js